import { MapUtils } from "../../../core/MapUtils";
import { ParamType } from "../../poly/ParamType";
import { ArrayUtils } from "../../../core/ArrayUtils";
import { NodePathParam } from "../../params/NodePath";
export class ReferencesController {
  constructor(scene) {
    this.scene = scene;
    this._referenced_nodes_by_src_param_id = /* @__PURE__ */ new Map();
    this._referencing_params_by_referenced_node_id = /* @__PURE__ */ new Map();
    this._referencing_params_by_all_named_node_ids = /* @__PURE__ */ new Map();
  }
  setReferenceFromParam(src_param, referencedGraphNode) {
    this._referenced_nodes_by_src_param_id.set(src_param.graphNodeId(), referencedGraphNode);
    MapUtils.pushOnArrayAtEntry(this._referencing_params_by_referenced_node_id, referencedGraphNode.graphNodeId(), src_param);
  }
  setNamedNodesFromParam(src_param) {
    const named_nodes = src_param.decomposedPath.named_nodes();
    for (let named_node of named_nodes) {
      MapUtils.pushOnArrayAtEntry(this._referencing_params_by_all_named_node_ids, named_node.graphNodeId(), src_param);
    }
  }
  resetReferenceFromParam(src_param) {
    const referenced_node = this._referenced_nodes_by_src_param_id.get(src_param.graphNodeId());
    if (referenced_node) {
      MapUtils.popFromArrayAtEntry(this._referencing_params_by_referenced_node_id, referenced_node.graphNodeId(), src_param);
      const named_nodes = src_param.decomposedPath.named_nodes();
      for (let named_node of named_nodes) {
        MapUtils.popFromArrayAtEntry(this._referencing_params_by_all_named_node_ids, named_node.graphNodeId(), src_param);
      }
      this._referenced_nodes_by_src_param_id.delete(src_param.graphNodeId());
    }
  }
  referencing_params(node) {
    return this._referencing_params_by_referenced_node_id.get(node.graphNodeId());
  }
  referencing_nodes(node) {
    const params = this._referencing_params_by_referenced_node_id.get(node.graphNodeId());
    if (params) {
      const node_by_node_id = /* @__PURE__ */ new Map();
      for (let param of params) {
        const node2 = param.node;
        node_by_node_id.set(node2.graphNodeId(), node2);
      }
      const nodes = [];
      node_by_node_id.forEach((node2) => {
        nodes.push(node2);
      });
      return nodes;
    }
  }
  nodes_referenced_by(node) {
    const path_param_types = /* @__PURE__ */ new Set([ParamType.NODE_PATH]);
    const path_params = [];
    for (let param of node.params.all) {
      if (path_param_types.has(param.type())) {
        path_params.push(param);
      }
    }
    const nodes_by_id = /* @__PURE__ */ new Map();
    const params = [];
    for (let path_param of path_params) {
      this._check_param(path_param, nodes_by_id, params);
    }
    for (let param of params) {
      nodes_by_id.set(param.node.graphNodeId(), param.node);
    }
    const nodes = [];
    nodes_by_id.forEach((node2) => {
      nodes.push(node2);
    });
    return nodes;
  }
  _check_param(param, nodes_by_id, params) {
    if (param instanceof NodePathParam) {
      const found_node = param.value.node();
      if (found_node) {
        nodes_by_id.set(found_node.graphNodeId(), found_node);
      }
      return;
    }
  }
  notifyNameUpdated(node) {
    const referencingParams = this._referencing_params_by_all_named_node_ids.get(node.graphNodeId());
    if (referencingParams) {
      const referencingParamsCloned = ArrayUtils.shallowClone(referencingParams);
      for (let referencingParam of referencingParamsCloned) {
        referencingParam.notifyPathRebuildRequired(node);
      }
    }
  }
  notifyParamsUpdated(node) {
    const referencingParams = this._referencing_params_by_all_named_node_ids.get(node.graphNodeId());
    if (referencingParams) {
      const referencingParamsCloned = ArrayUtils.shallowClone(referencingParams);
      for (let referencingParam of referencingParamsCloned) {
        if (referencingParam.options.isSelectingParam()) {
          referencingParam.notifyTargetParamOwnerParamsUpdated(node);
        }
      }
    }
  }
}
